import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';

    public data: any = {
        userid: '',
        password: ''
    };

    public registerData: any = {
        userid: '',
        password: '',
        passwordConfirm: '',
        name: '',
        mobile: ''
    };

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = "/";
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.userid) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            location.href = "/";
            await this.service.render();
        } else {
            await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        }
    }

    public showRegister() {
        this.view = 'register';
        this.registerData = { userid: '', password: '', passwordConfirm: '', name: '', mobile: '' };
        this.service.render();
    }

    public showLogin() {
        this.view = 'login';
        this.data = { userid: '', password: '' };
        this.service.render();
    }

    public async register() {
        let d = this.registerData;

        if (!d.userid) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (d.userid.length < 3) {
            await this.alert("아이디는 3자 이상이어야 합니다.");
            return;
        }
        if (!d.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }
        if (d.password.length < 4) {
            await this.alert("비밀번호는 4자 이상이어야 합니다.");
            return;
        }
        if (d.password !== d.passwordConfirm) {
            await this.alert("비밀번호가 일치하지 않습니다.");
            return;
        }
        if (!d.name) {
            await this.alert("이름을 입력해주세요.");
            return;
        }

        let { code, data } = await wiz.call("register", {
            userid: d.userid,
            password: d.password,
            name: d.name,
            mobile: d.mobile
        });

        if (code == 200) {
            await this.alert("계정이 생성되었습니다. 로그인해주세요.", 'success');
            this.showLogin();
        } else {
            await this.alert(data.message || "계정 생성에 실패했습니다.", 'error');
        }
    }
}

export default PageAccessComponent;